import {HttpClient} from "@angular/common/http";
import {Inject, Injectable} from "@angular/core";
import {Payload} from "../../../../core/service/payload/payload";
import {environment} from "../../../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class AiTranscriptionImproveService {

    constructor(private httpClient: HttpClient){
    }

    execute(payload: AiTranscriptionImproveServicePayload): Promise<AiTranscriptionImproveServiceResult> {
        return this.httpClient.post<AiTranscriptionImproveServiceResult>(environment.webserviceUrl + '/v1/ai/transcription/improve', payload)
            .toPromise();
    }
}

export class AiTranscriptionImproveServicePayload implements Payload{
    transcription: string;
    existingText?: string;
}

export class AiTranscriptionImproveServiceResult {
    text: string;
}

